import React from 'react';
import { Router, LocationProvider } from '@reach/router';
import { history } from './utils/router-history';

import { PageView } from './utils/ga';
import Provider from './providers/provider';

import NotFound from './pages/404';
import IndexPage from './pages/home';
import Ofertas from './pages/ofertas';
import Oferta from './pages/ofertas/oferta';

history.listen(({ location }) => {
	PageView(location.pathname);
});

const App = () => {
	return (
		<Provider>
			<LocationProvider history={history}>
				<Router>
					<IndexPage path='/' component={IndexPage} />
					<Ofertas path='/jobs' component={Ofertas} />
					<Oferta path='/jobs/:offerId' component={Oferta} />
					<NotFound default />
				</Router>
			</LocationProvider>
		</Provider>
	);
};

export default App;
